module.exports = __webpack_public_path__ + "img/logoTeleSaude.3caa41c7.png";